import CompanySetup from './CompanySetup'
export default CompanySetup
